/* @generated */

// src/assets/ui-icon/line/photo-upload.tsx
import * as React from "react";
var PhotoUploadLine = (props) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 24 24", fill: "none", ...props }, /* @__PURE__ */ React.createElement(
  "path",
  {
    d: "m18.25 3.46-2.86 2.75 1.04 1.08 1.07-1.029V10H19V6.261l1.07 1.03 1.04-1.082-2.86-2.75ZM8.5 10a1.393 1.393 0 0 0 1.5 1.5 1.392 1.392 0 0 0 1.5-1.5A1.392 1.392 0 0 0 10 8.5 1.393 1.393 0 0 0 8.5 10Z",
    fill: "currentColor",
    vectorEffect: "non-scaling-stroke"
  }
), /* @__PURE__ */ React.createElement(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m18.51 12.451.49.489V19H5V5h9.213v1.5h-7.71v6.366a2.224 2.224 0 0 1 2.7.356l.378.378a.75.75 0 0 0 1.061 0l2.173-2.17a3.253 3.253 0 0 1 4.595 0l1.1 1.021ZM6.5 14.864V17.5h11l-.002-3.938-.03-.03-1.1-1.021a1.76 1.76 0 0 0-2.495-.02l-2.171 2.172a2.253 2.253 0 0 1-3.182 0l-.379-.379a.75.75 0 0 0-1.061 0l-.58.58Z",
    fill: "currentColor",
    vectorEffect: "non-scaling-stroke"
  }
));
export {
  PhotoUploadLine
};
